export default {
	// The Views, Processes, Activities and Types overviews: the cards (EntityCard and its facts) and
	// the toolbar above them.
	overview: {
		noPreview: "No preview yet",
		definedIn: "Defined in {alias}",
		editInOwnProject: "Edit it in its own project",
		noDescription: "No description",
		noTags: "No tags",
		moreTags: "{count} more tags: {tags}",
		dataobjectsInView: "Dataobjects in this view",
		dataobjectsInProcess: "Dataobjects in this process",
		moreDataobjects: "{count} more",
		noDataobjects: "No dataobjects yet",
		activityCount: "{count} activity | {count} activities",
		noActivities: "No activities attached",
		actionCount: "{count} action | {count} actions",
		usedIn: "Used in",
		notUsed: "Not used in any process",
		copyCodeName: "Copy code name",
		copyLink: "Copy link",
		copied: "Copied to the clipboard",
		copyFailed: "Could not copy to the clipboard",
		// The overviews' ListToolbar: how a list is ordered and narrowed.
		sort: {
			label: "Sort",
			name: "Name",
			recent: "Recently opened",
			terminology: "Terminology",
			dataobjects: "Dataobjects",
			activities: "Activities",
			actions: "Actions",
			values: "Values",
			attributes: "Attributes",
			reverseHint: "Click again to reverse",
			reversed: "reversed",
		},
		filter: {
			tag: "Tag",
			dataobject: "Dataobject",
			origin: "Defined in",
			local: "This project",
			show: "Show",
			all: "All",
			unused: "Not used in any process",
			noActivities: "Without activities",
			clear: "Clear filters",
		},
	},
};
